import React, {useState} from 'react';

import {MinimalFolder} from 'constants/FolderConstants';
import * as RegistryUtil from 'registry/RegistryUtil';
import {useDebounce} from 'ui-library/hooks/useDebounce';
import {Size} from 'ui-library/inputs/InputConstants';
import TextInput from 'ui-library/inputs/TextInput';
import SelectTree from 'ui-library/select-tree/SelectTree';

import * as FileSelectorUtil from './FileSelectorUtil';

export interface FolderSelectTreeProps {
  allowNone?: boolean;
  className?: string;
  folderIds: Array<string>;
  onChangeSelectedFolders: (folderIds: Array<string>) => void;
  folders: Array<MinimalFolder>;
  includeHiddenProjects?: boolean;
  multiple: boolean;
  submitHandler?: () => void;
}

export default function FolderSelectTree({
  includeHiddenProjects = false,
  allowNone = false,
  ...props
}: FolderSelectTreeProps): JSX.Element {
  const [query, setQuery] = useState('');
  const debouncedQuery = useDebounce(query, 500);
  const [loading, setLoading] = useState(false);

  let folders = props.folders;
  if (!includeHiddenProjects) {
    folders = folders.filter(({source}) => source && !source.hidden && !source.archived);
  }
  const hasRegistries = props.folders.some((folder) => RegistryUtil.isRegistry(folder.source));
  return (
    <div>
      <TextInput
        value={query}
        placeholder="Filter..."
        onChange={(e) => {
          setQuery(e.target.value);
          setLoading(true);
        }}
        size={Size.SMALL}
      />
      <SelectTree
        allowNone={allowNone}
        className={props.className}
        items={FileSelectorUtil.foldersToSelectTreeItems(folders)}
        multiple={props.multiple}
        selectAllText={hasRegistries ? 'All Projects and Registries' : 'All Projects'}
        selectedIds={props.folderIds}
        onChangeSelectedIds={props.onChangeSelectedFolders}
        submitHandler={props.submitHandler}
        shouldExpandNewItems={false}
        query={debouncedQuery}
        isLoading={loading}
        setIsLoading={setLoading}
      />
    </div>
  );
}
